module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "component-groups"
  }, [_c('header', {
    staticClass: "page-header page-header--inverted groups-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.salutation))]), (!_vm.isActive) ? _c('p', [_vm._v("Deze school is gearchiveerd.")]) : (_vm.groups.length) ? _c('p', [_vm._v("Kies een klas om te beginnen")]) : _c('p', [_vm._v("Voeg een klas toe om te beginnen.")])]), _c('div', {
    staticClass: "groups-content"
  }, [(_vm.loading) ? _c('loading') : _vm._e(), (_vm.groups.length) ? _c('transition-group', {
    staticClass: "teacher-groups",
    attrs: {
      "name": "insertion-bottom",
      "appear": "",
      "tag": "ol"
    }
  }, _vm._l((_vm.groups), function(group) {
    return _c('li', {
      key: group.id,
      staticClass: "teacher-groups__item"
    }, [(_vm.isFinished(group)) ? _c('span', {
      staticClass: "group-message note note--warning"
    }, [_c('strong', [_vm._v("Let op:")]), _vm._v(" Deze klas is klaar. Na " + _vm._s(_vm.archiveAt(group)) + " kunt u de werkmappen niet meer inzien.")]) : _vm._e(), _c('a', {
      staticClass: "button--settings",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showGroupSettings(group)
        }
      }
    }, [_vm._v("Instellingen")]), _c('h2', [_vm._v(_vm._s(group.name))]), _c('primary-button', {
      attrs: {
        "link": {
          name: 'students.overview',
          params: {
            groupId: group.id
          }
        }
      }
    }, [_vm._v("Bekijk")])], 1)
  })) : _vm._e(), (_vm.isActive) ? _c('a', {
    staticClass: "button-rounded button-add button-add-group",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSchoolGroups($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon icon--add"
  }), _vm._v("Klas toevoegen")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-493b464e","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/groups/Groups.vue
// module id = sNcH
// module chunks = 1